// @flow
export const filterId: 'sellTypeOnlyComplex' = 'sellTypeOnlyComplex';
